import React, { useState, useEffect } from "react";
import ClipboardJS from "clipboard";
import { ToastContainer, toast } from "react-toastify";

export default function Home() {

	const [pass, setPass] = useState("");
	const [maxLength, setMaxLength] = useState(16);
	const [lower, setLower] = useState(true);
	const [upper, setUpper] = useState(true);
	const [chars, setChars] = useState(true);
	const [num, setNum] = useState(true);

	useEffect(() => {
		new ClipboardJS(".btn-outline");
		onGenerate(maxLength);
	}, []);

	const onCopy = () => {
		toast.dark("🦄  Copied!", {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
		});
	};

	const openModal = () => {
		var modal = document.querySelector(".modal");
		modal.style.display = "flex";
	};

	const closeModal = () => {
		var modal = document.querySelector(".modal");
		modal.style.display = "none";
	};

	const onGenerate = (length) => {
		let low = lower ? "abcdefghijklmnopqrstuvwxyz" : "";
		let up = upper ? "ABCDEFGHIJKLMNOPQRSTUVWXYZ": "";
		let characters = chars ? ".!@#$%^&*(+)[}{]-+</>" : "";
		let numbers = num ? "0123456789" : "";
		let base = (low+characters+up+numbers).toString();
		var token = "";
		for (var x = 0; x < length; x++) {
			var i = Math.floor(Math.random() * base.length);
			token += base.charAt(i);
		}
		setPass(token);
	};

	return(
		<div className="app">

			<div className="container">

				<h1 className="title">Random password generator</h1>
				<span className="description">Random, simple, safe and impenetrable</span>
				<textarea className="panelbox" onChange={() => {}} value={pass} spellCheck="false" ></textarea>
				<button alt="Generate new password" className="btn" onClick={() => onGenerate(maxLength)} >
					<span>
						Generate new password
					</span>
				</button>
				<button alt="copy password" className="btn-outline" data-clipboard-target=".panelbox" onClick={() => onCopy()} >
					<span>
						Copy password
					</span>
					<i className="bx bx-clipboard"></i>
				</button>

				<div className="modal">
					<div className="modal-header">
						<h1 className="title">Settings</h1>
					</div>
					<div className="modal-body">
						<div className="modal-body-item">
							<span>Password size</span>
							<input className="range" type="number" onChange={(e) => setMaxLength(e.target.value)} value={maxLength} />
						</div>
						<div className="modal-body-item">
							<span>Lowercase (a-z)</span>
							<input id="lower" className="checkbox" onChange={(e) => setLower(e.target.checked)} type="checkbox" checked={lower} />
						</div>
						<div className="modal-body-item">
							<span>Uppercase (A-Z)</span>
							<input id="upper" className="checkbox" type="checkbox" onChange={(e) => setUpper(e.target.checked)} checked={upper} />
						</div>
						<div className="modal-body-item">
							<span>Number (0-9)</span>
							<input id="number" className="checkbox" type="checkbox" onChange={(e) => setNum(e.target.checked)} checked={num} />
						</div>
						<div className="modal-body-item">
							<span>Characters (@#$%)</span>
							<input id="chars" className="checkbox" type="checkbox" onChange={(e) => setChars(e.target.checked)} checked={chars} />
						</div>
					</div>
					<div className="modal-footer">
						<button className="modal-close" onClick={() => closeModal()}>
							<span>
									Save
							</span>
						</button>
					</div>
				</div>

			</div>

			<div>
				<button className="fab" onClick={() => openModal()}>
					<i className="bx bx-slider-alt"></i>
				</button>
			</div>

			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
			<ToastContainer />
		</div>
	);
}